import Vuex from "vuex";
import Vue from "vue";
Vue.use(Vuex);

// State
const state = () => ({
  jobIDs: [],
  saveallsearchData: {},
  modifyallsearchData: {},
  appliedSearch: {},
  whereFrom: "",
});

// getters
const getters = {
  getJobIDs: (state) => state.jobIDs,
  getsaveallsearchData: (state) => state.saveallsearchData,
  getmodifyallsearchData: (state) => state.modifyallsearchData,
  getAppliedSearch: (state) => state.appliedSearch,
  whereFrom: (state) => state.whereFrom,
};

const actions = {
  async searchProfilesData({ commit }, payload) {
    commit("saveallsearch", payload);
  },
  async modifyData({ commit }, payload) {
    let data = payload;
    commit("modifyallsearchDataMethod", data);
  },
};

// mutations
const mutations = {
  setJobIDs(state, payload) {
    state.jobIDs = payload;
  },
  setWhereFrom(state, payload) {
    state.whereFrom = payload;
  },
  saveallsearch(state, payload) {
    state.saveallsearchData = payload;
  },
  modifyallsearchData(state, payload) {
    state.modifyallsearchData = payload;
  },
  saveAppliedSearch(state, payload) {
    state.appliedSearch = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
